import { UserModel } from "./models";
import { LOCALES } from "./translation";
// An enum with all the types of actions to use in our reducer
export enum ContextActions {
  LOGIN = "login",
  LOGOUT = "logout",
  LANGUAGE = "language",
  UPDATE_LOADING = "update_loading",
  LOCALE = "locale"
}

// An interface for our actions
export type ContextAction =
  | {
      type: ContextActions.LOGIN;
      value: UserModel;
    }
  | {
      type: ContextActions.UPDATE_LOADING;
      value?: boolean;
    }
  | {
      type: ContextActions.LOGOUT;
    }
  | {
      type: ContextActions.LOCALE;
      value: LOCALES;
    };

// Context Values
export interface IContext {
  userData: UserModel | null;
  loadingUser: boolean;
  locale: LOCALES;
}
